import { render, staticRenderFns } from "./FileViewerImageLarge.vue?vue&type=template&id=2d9fd7f8&scoped=true&"
import script from "./FileViewerImageLarge.vue?vue&type=script&lang=js&"
export * from "./FileViewerImageLarge.vue?vue&type=script&lang=js&"
import style0 from "./FileViewerImageLarge.vue?vue&type=style&index=0&id=2d9fd7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9fd7f8",
  null
  
)

export default component.exports